import { Checkbox as AntCheckbox } from 'antd';
import { CheckboxProps } from 'antd/lib/checkbox/Checkbox';
import styled from 'styled-components';

interface ICheckboxProps extends CheckboxProps {
  borderColor?: string;
  backgroundColor?: string;
  color?: string;
}

const defaultBorderColor = '#494949';

const modifyAntCheckboxBorderColor = ({ borderColor = defaultBorderColor }) => {
  return borderColor;
};

const modifyAntCheckboxColor = ({ color = '#4a4a4a' }) => {
  return color;
};

const modifyAntCheckboxBackgroundColor = ({ backgroundColor = '#fff' }) => {
  return backgroundColor;
};

export const Checkbox = styled(AntCheckbox)<ICheckboxProps>`
  & {
    color: ${modifyAntCheckboxColor};

    &:hover .emp-ant-checkbox-inner {
      border-color: ${modifyAntCheckboxBorderColor};
    }

    .emp-ant-checkbox-input:focus + .emp-ant-checkbox-inner {
      border-color: ${modifyAntCheckboxBorderColor};
    }

    &:hover .emp-ant-checkbox-inner {
      border-color: ${modifyAntCheckboxBorderColor};
    }
  }

  .emp-ant-checkbox-checked {
    &::after {
      border-color: ${modifyAntCheckboxBorderColor};
    }

    .emp-ant-checkbox-inner {
      background-color: ${modifyAntCheckboxBackgroundColor};
      border-color: ${modifyAntCheckboxBorderColor};

      &::after {
        border-color: ${modifyAntCheckboxBorderColor};
      }
    }
  }
}
`;
